import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=6163%3A10866
 *
 * @param {SvgIconProps} props - svg props
 */
export const AddPhonesIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M1.00814 5.20046C0.903019 4.02173 1.82911 3 3.01251 3H5.5917C6.77509 3 7.70118 4.02171 7.59607 5.20042C7.37406 7.69014 7.05215 11.6973 7.05215 14C7.05215 15.6439 7.21621 17.2814 7.39087 18.5589C7.56344 19.8211 6.59995 21 5.32597 21H3.27829C2.00428 21 1.04078 19.8211 1.21338 18.5588C1.38806 17.2814 1.55215 15.6439 1.55215 14C1.55215 11.6973 1.23019 7.69017 1.00814 5.20046Z' fill={color}/>
            <path fillRule='evenodd' clipRule='evenodd' d='M20.9996 3H8L8.12778 3.06903C8.81225 3.43882 9.22017 4.17198 9.17353 4.94856L8.31672 19.2139C8.27523 19.9046 7.87971 20.5247 7.27097 20.8536L7 21H20.9996C22.1042 21 22.9996 20.1046 22.9996 19V5C22.9996 3.89543 22.1042 3 20.9996 3ZM14.6429 8.28571C14.6429 8.12792 14.7708 8 14.9286 8H16.0714C16.2292 8 16.3571 8.12792 16.3571 8.28571V11.1429H19.2143C19.3721 11.1429 19.5 11.2708 19.5 11.4286V12.5714C19.5 12.7292 19.3721 12.8571 19.2143 12.8571H16.3571V15.7143C16.3571 15.8721 16.2292 16 16.0714 16H14.9286C14.7708 16 14.6429 15.8721 14.6429 15.7143V12.8571H11.7857C11.6279 12.8571 11.5 12.7292 11.5 12.5714V11.4286C11.5 11.2708 11.6279 11.1429 11.7857 11.1429H14.6429V8.28571Z' fill={color}/>
        </SvgIcon>
    )
}

export default AddPhonesIcon
